import filter from 'lodash/filter'
import map from 'lodash/map'

import { ITermbaseEntryImportData } from '@SiteModules/Termbase/types'

export default function convertImportedTermbaseEntryData(
  rows: string[][],
  sourceTermsColumnIndex: number,
  sourcePronunciationColumnIndex: number | null,
  translationTermsColumnIndex: number | null,
  targetPronunciationColumnIndex: number | null,
  sourceLanguageCode: string,
  targetLanguageCode: string
): ITermbaseEntryImportData[][] {
  return filter(
    map(rows, row => {
      const entriesByLang: Record<string, ITermbaseEntryImportData> = {}

      // --- Source term ---
      const sourceTerm = row[sourceTermsColumnIndex]?.trim()
      if (sourceTerm) {
        entriesByLang[sourceLanguageCode] = {
          language: sourceLanguageCode,
          term: sourceTerm,
        }
      }

      // --- Source pronunciation ---
      if (sourcePronunciationColumnIndex !== null) {
        const sourcePron = row[sourcePronunciationColumnIndex]?.trim()
        if (sourcePron) {
          if (!entriesByLang[sourceLanguageCode]) {
            entriesByLang[sourceLanguageCode] = { language: sourceLanguageCode }
          }
          entriesByLang[sourceLanguageCode].pronunciation = sourcePron
        }
      }

      // --- Target term ---
      if (translationTermsColumnIndex !== null && targetLanguageCode) {
        const targetTerm = row[translationTermsColumnIndex]?.trim()
        if (targetTerm) {
          entriesByLang[targetLanguageCode] = {
            language: targetLanguageCode,
            term: targetTerm,
          }
        }
      }

      // --- Target pronunciation ---
      if (targetPronunciationColumnIndex !== null && targetLanguageCode) {
        const targetPron = row[targetPronunciationColumnIndex]?.trim()
        if (targetPron) {
          if (!entriesByLang[targetLanguageCode]) {
            entriesByLang[targetLanguageCode] = { language: targetLanguageCode }
          }
          entriesByLang[targetLanguageCode].pronunciation = targetPron
        }
      }

      // ✅ Explicitly order: source first, then target
      const orderedEntries: ITermbaseEntryImportData[] = []
      if (entriesByLang[sourceLanguageCode]) {
        orderedEntries.push(entriesByLang[sourceLanguageCode])
      }
      if (targetLanguageCode && entriesByLang[targetLanguageCode]) {
        orderedEntries.push(entriesByLang[targetLanguageCode])
      }

      return orderedEntries
    }),
    entryGroup => entryGroup.length > 0
  )
}
